// extracted by mini-css-extract-plugin
module.exports = {"viewMoreSection":"_1uDVnq7Y","viewMore":"_1PCyu2Kp"};